import React, { useState, useEffect } from 'react';
import axios from 'axios';

const SponsorManager = () => {
  const [sponsors, setSponsors] = useState([]);
  const [sections, setSections] = useState([]);
  const [showForm, setShowForm] = useState(false);
  const [editingItem, setEditingItem] = useState(null);
  const [formData, setFormData] = useState({
    name: '',
    website_url: '',
    description: '',
    description_color: '#fbbf24',
    tier: 'guvenilir',
    section_id: '',
    size: 'medium',
    button1_text: 'Siteye Git',
    button1_link: '',
    order_index: 0,
    is_active: true,
    is_ad_card: false,
    ticket_multiplier: 1
  });
  const [logoFile, setLogoFile] = useState(null);
  const [bgImageFile, setBgImageFile] = useState(null);
  const [loading, setLoading] = useState(false);

  const tierOptions = [
    { value: 'ana-sponsor', label: 'Ana Sponsor' },
    { value: 'premium-sponsor', label: 'Premium Sponsor' },
    { value: 'altin-sponsor', label: 'Altın Sponsor' },
    { value: 'gumus-sponsor', label: 'Gümüş Sponsor' },
    { value: 'guvenilir', label: 'Güvenilir Site' },
    { value: 'reklam-alani', label: 'Reklam Alanı' },
  ];

  const sizeOptions = [
    { value: 'hero', label: 'Hero Kart - En büyük, yatay, tek sıraya 1 tane (Ana sponsor alanında)' },
    { value: 'large', label: 'Büyük Kart - Bir sıraya 2 tane, dinamik ve göze çarpan (Ana sponsor alanında)' },
    { value: 'medium', label: 'Orta Kart - Bir sıraya 4 tane, açıklama ve buton gözükür (VIP sponsor kısmında)' },
    { value: 'small', label: 'Küçük Kart - Bir sıraya 4 tane, açıklama gözükür, basit tasarım' },
  ];

  useEffect(() => {
    fetchData();
  }, []);

  const fetchData = async () => {
    try {
      const token = localStorage.getItem('adminToken');
      const [sponsorsRes, sectionsRes] = await Promise.all([
        axios.get('/api/sponsors', {
          headers: { Authorization: `Bearer ${token}` }
        }),
        axios.get('/api/sections?page=sponsors', {
          headers: { Authorization: `Bearer ${token}` }
        })
      ]);
      setSponsors(sponsorsRes.data);
      setSections(sectionsRes.data);
    } catch (error) {
      console.error('Error fetching data:', error);
    }
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    
    // Form validation
    if (!formData.name || !formData.tier) {
      alert('Sponsor adı ve seviye zorunludur');
      return;
    }
    
    // Normal sponsor için logo kontrolü (reklam kartı için logo opsiyonel)
    if (formData.tier !== 'reklam-alani' && !formData.is_ad_card && !logoFile && !editingItem) {
      alert('Normal sponsor için logo zorunludur');
      return;
    }
    
    // Normal sponsor için buton kontrolü
    if (formData.tier !== 'reklam-alani' && !formData.is_ad_card && (!formData.button1_text || !formData.button1_link)) {
      alert('Normal sponsor için buton yazısı ve linki zorunludur');
      return;
    }
    
    // Reklam kartı için buton alanlarını kontrol etme
    const submitData = { ...formData };
    // Reklam alanı seviyesi seçildiyse otomatik olarak reklam kartı yap
    if (submitData.tier === 'reklam-alani') {
      submitData.is_ad_card = true;
    }
    if (submitData.is_ad_card || submitData.tier === 'reklam-alani') {
      // Reklam kartı için varsayılan değerler
      if (!submitData.button1_text) {
        submitData.button1_text = 'İletişime Geç';
      }
      if (!submitData.button1_link) {
        submitData.button1_link = '#';
      }
    }
    
    setLoading(true);

    try {
      const token = localStorage.getItem('adminToken');
      const formDataToSend = new FormData();
      
      if (logoFile) {
        formDataToSend.append('logo', logoFile);
      } else if (editingItem) {
        formDataToSend.append('logo_url', editingItem.logo_url || '');
      } else if (submitData._copiedLogoUrl) {
        // Kopyalama durumunda logo URL'ini kullan
        formDataToSend.append('logo_url', submitData._copiedLogoUrl);
      } else {
        // Logo yoksa boş string gönder (backend kontrol edecek)
        formDataToSend.append('logo_url', '');
      }

      // Arkaplan görseli opsiyoneldir - varsayılan olarak görselsiz kalır
      if (bgImageFile) {
        formDataToSend.append('bg_image', bgImageFile);
      } else if (editingItem) {
        formDataToSend.append('bg_image_url', editingItem.bg_image_url || '');
      } else if (submitData._copiedBgImageUrl) {
        formDataToSend.append('bg_image_url', submitData._copiedBgImageUrl);
      } else {
        formDataToSend.append('bg_image_url', '');
      }

      // FormData'ya tüm alanları ekle
      formDataToSend.append('name', submitData.name);
      formDataToSend.append('tier', submitData.tier);
      formDataToSend.append('website_url', submitData.website_url || '');
      formDataToSend.append('description', submitData.description || '');
      formDataToSend.append('description_color', submitData.description_color || '#fbbf24');
      formDataToSend.append('section_id', submitData.section_id || '');
      formDataToSend.append('order_index', submitData.order_index || 0);
      formDataToSend.append('size', submitData.size || 'medium');
      formDataToSend.append('button1_text', submitData.button1_text || 'Siteye Git');
      formDataToSend.append('button1_link', submitData.button1_link || '');
      formDataToSend.append('is_active', submitData.is_active ? 'true' : 'false');
      formDataToSend.append('is_ad_card', (submitData.is_ad_card || submitData.tier === 'reklam-alani') ? 'true' : 'false');
      formDataToSend.append('ticket_multiplier', submitData.ticket_multiplier || 1);

      if (editingItem) {
        await axios.put(`/api/sponsors/${editingItem.id}`, formDataToSend, {
          headers: { 
            Authorization: `Bearer ${token}`,
            'Content-Type': 'multipart/form-data'
          }
        });
      } else {
        await axios.post('/api/sponsors', formDataToSend, {
          headers: { 
            Authorization: `Bearer ${token}`,
            'Content-Type': 'multipart/form-data'
          }
        });
      }

      fetchData();
      resetForm();
      alert('Sponsor başarıyla eklendi!');
    } catch (error) {
      console.error('Error saving sponsor:', error);
      console.error('Error details:', {
        message: error.message,
        response: error.response?.data,
        status: error.response?.status,
        formData: submitData
      });
      const errorMessage = error.response?.data?.error || error.message || 'Bilinmeyen hata';
      alert('Kaydetme hatası: ' + errorMessage);
    } finally {
      setLoading(false);
    }
  };

  const handleDelete = async (id) => {
    if (!window.confirm('Bu sponsoru silmek istediğinizden emin misiniz?')) {
      return;
    }

    try {
      const token = localStorage.getItem('adminToken');
      await axios.delete(`/api/sponsors/${id}`, {
        headers: { Authorization: `Bearer ${token}` }
      });
      fetchData();
    } catch (error) {
      console.error('Error deleting sponsor:', error);
      alert('Silme hatası');
    }
  };

  const handleEdit = (item) => {
    setEditingItem(item);
    setFormData({
      name: item.name,
      website_url: item.website_url || '',
      description: item.description || '',
      description_color: item.description_color || '#fbbf24',
      tier: item.tier,
      section_id: item.section_id || '',
      size: item.size || 'medium',
      button1_text: item.button1_text || 'Siteye Git',
      button1_link: item.button1_link || item.website_url || '',
      order_index: item.order_index,
      is_active: item.is_active,
      is_ad_card: item.is_ad_card === 1 || item.is_ad_card === true,
      ticket_multiplier: item.ticket_multiplier || item.ticketMultiplier || 1
    });
    setBgImageFile(null);
    setShowForm(true);
  };

  const handleCopy = (item) => {
    // Kopyalama için editingItem null olmalı (yeni kayıt olarak eklenecek)
    // Ancak logo URL'ini korumak için item'ı geçici olarak saklayalım
    setEditingItem(null);
    setLogoFile(null); // Logo dosyasını sıfırla
    setBgImageFile(null);
    setFormData({
      name: item.name + ' (Kopya)', // İsme "Kopya" ekle
      website_url: item.website_url || '',
      description: item.description || '',
      description_color: item.description_color || '#fbbf24',
      tier: item.tier,
      section_id: item.section_id || '',
      size: item.size || 'medium',
      button1_text: item.button1_text || 'Siteye Git',
      button1_link: item.button1_link || item.website_url || '',
      order_index: item.order_index,
      is_active: item.is_active,
      is_ad_card: item.is_ad_card === 1 || item.is_ad_card === true,
      ticket_multiplier: item.ticket_multiplier || item.ticketMultiplier || 1,
      // Logo URL'ini formData'ya ekle (kopyalama için)
      _copiedLogoUrl: item.logo_url || '',
      _copiedBgImageUrl: item.bg_image_url || ''
    });
    setShowForm(true);
    // Form'a scroll yap
    setTimeout(() => {
      const formElement = document.querySelector('form');
      if (formElement) {
        formElement.scrollIntoView({ behavior: 'smooth', block: 'start' });
      }
    }, 100);
  };

  const resetForm = () => {
    setFormData({
      name: '',
      website_url: '',
      description: '',
      description_color: '#fbbf24',
      tier: 'guvenilir',
      section_id: '',
      size: 'medium',
      button1_text: 'Siteye Git',
      button1_link: '',
      order_index: 0,
      is_active: true,
      is_ad_card: false,
      ticket_multiplier: 1
    });
    setLogoFile(null);
    setBgImageFile(null);
    setEditingItem(null);
    setShowForm(false);
  };

  return (
    <div className="bg-gradient-card rounded-xl p-6 border border-gold/30">
      <div className="flex justify-between items-center mb-6">
        <h2 className="text-2xl font-bold text-gold">Sponsor Yönetimi</h2>
        <button
          onClick={() => setShowForm(!showForm)}
          className="bg-gradient-to-r from-gold to-yellow-500 hover:from-yellow-500 hover:to-gold text-navy-900 font-bold px-4 py-2 rounded-lg transition-all duration-300 shadow-gold"
        >
          {showForm ? 'İptal' : '+ Yeni Sponsor'}
        </button>
      </div>

      {showForm && (
        <form onSubmit={handleSubmit} noValidate className="bg-navy-700 p-6 rounded-lg mb-6 space-y-4">
          <div>
            <label className="block text-white mb-2">Sponsor Adı *</label>
            <input
              type="text"
              value={formData.name}
              onChange={(e) => setFormData({ ...formData, name: e.target.value })}
              className="w-full px-3 py-2 bg-navy-600 border border-gold/30 rounded text-white"
              required
            />
          </div>

          <div>
            <label className="block text-white mb-2">
              Logo {!editingItem && !formData.is_ad_card && formData.tier !== 'reklam-alani' && '*'}
              {(formData.is_ad_card || formData.tier === 'reklam-alani') && (
                <span className="text-gold text-xs ml-2">(Reklam kartı için görsel ekleyebilirsiniz)</span>
              )}
            </label>
            <input
              type="file"
              accept="image/*"
              onChange={(e) => setLogoFile(e.target.files[0])}
              className="w-full px-3 py-2 bg-navy-600 border border-gold/30 rounded text-white"
              required={!editingItem && !formData.is_ad_card && formData.tier !== 'reklam-alani'}
            />
            {(formData.is_ad_card || formData.tier === 'reklam-alani') && (
              <p className="text-white/60 text-xs mt-1">Reklam kartı için görsel ekleyebilirsiniz. Görsel varsa "REKLAM VER" yazısının üstünde gösterilir.</p>
            )}
          </div>

          <div>
            <label className="block text-white mb-2">
              Arkaplan Görseli <span className="text-white/50 text-xs ml-1">(opsiyonel)</span>
            </label>
            <input
              type="file"
              accept="image/*"
              onChange={(e) => setBgImageFile(e.target.files[0])}
              className="w-full px-3 py-2 bg-navy-600 border border-gold/30 rounded text-white"
            />
            <p className="text-white/60 text-xs mt-1">
              Sponsorlar sayfasındaki kartın arkasında tam boy gösterilen görsel. Boş bırakılırsa kart varsayılan altın parıltılı arkaplanla gösterilir.
            </p>
            {editingItem && editingItem.bg_image_url && !bgImageFile && (
              <div className="mt-2 flex items-center gap-2">
                <img src={editingItem.bg_image_url} alt="Mevcut arkaplan" className="w-16 h-16 object-cover rounded border border-gold/30" />
                <span className="text-white/60 text-xs">Mevcut arkaplan görseli (değiştirmek için yeni dosya seçin)</span>
              </div>
            )}
          </div>

          <div>
            <label className="block text-white mb-2">Website URL</label>
            <input
              type="url"
              value={formData.website_url}
              onChange={(e) => setFormData({ ...formData, website_url: e.target.value })}
              className="w-full px-3 py-2 bg-navy-600 border border-gold/30 rounded text-white"
              placeholder="https://example.com"
            />
          </div>

          <div>
            <label className="block text-white mb-2">Açıklama</label>
            <textarea
              value={formData.description}
              onChange={(e) => setFormData({ ...formData, description: e.target.value })}
              className="w-full px-3 py-2 bg-navy-600 border border-gold/30 rounded text-white"
              rows="3"
              placeholder="İlk satır renkli başlık olacak, diğer satırlar beyaz"
            />
          </div>

          <div>
            <label className="block text-white mb-2">Açıklama Başlık Rengi</label>
            <div className="flex gap-2">
              <input
                type="color"
                value={formData.description_color}
                onChange={(e) => setFormData({ ...formData, description_color: e.target.value })}
                className="w-16 h-10 bg-navy-600 border border-gold/30 rounded cursor-pointer"
              />
              <input
                type="text"
                value={formData.description_color}
                onChange={(e) => setFormData({ ...formData, description_color: e.target.value })}
                className="flex-1 px-3 py-2 bg-navy-600 border border-gold/30 rounded text-white"
              />
            </div>
          </div>

          <div>
            <label className="block text-white mb-2">Sponsor Seviyesi *</label>
            <select
              value={formData.tier}
              onChange={(e) => {
                const newTier = e.target.value;
                // Reklam Alanı seçildiğinde otomatik olarak reklam kartını işaretle
                setFormData({ 
                  ...formData, 
                  tier: newTier,
                  is_ad_card: newTier === 'reklam-alani' ? true : formData.is_ad_card
                });
              }}
              className="w-full px-3 py-2 bg-navy-600 border border-gold/30 rounded text-white"
              required
            >
              {tierOptions.map(option => (
                <option key={option.value} value={option.value}>{option.label}</option>
              ))}
            </select>
          </div>

          <div>
            <label className="block text-white mb-2">Kart Boyutu *</label>
            <select
              value={formData.size}
              onChange={(e) => setFormData({ ...formData, size: e.target.value })}
              className="w-full px-3 py-2 bg-navy-600 border border-gold/30 rounded text-white"
              required
            >
              {sizeOptions.map(option => (
                <option key={option.value} value={option.value}>{option.label}</option>
              ))}
            </select>
            <p className="text-white/60 text-xs mt-1">Büyük: 1 kart/sıra, Orta: 2 kart/sıra, Küçük: 4 kart/sıra</p>
          </div>

          <div className="border-t border-gold/20 pt-4 mt-4">
            <div className={`flex items-center gap-3 p-4 rounded-lg border ${formData.tier === 'reklam-alani' ? 'bg-amber-900/30 border-gold/50' : 'bg-amber-900/20 border-gold/30'}`}>
              <input
                type="checkbox"
                checked={formData.is_ad_card || formData.tier === 'reklam-alani'}
                onChange={(e) => {
                  // Eğer reklam alanı seçiliyse checkbox'ı değiştiremez
                  if (formData.tier === 'reklam-alani') {
                    return;
                  }
                  setFormData({ ...formData, is_ad_card: e.target.checked });
                }}
                disabled={formData.tier === 'reklam-alani'}
                className="w-5 h-5 text-gold rounded focus:ring-gold disabled:opacity-50"
              />
              <div className="flex-1">
                <label className="text-white font-semibold cursor-pointer">
                  Reklam Kartı
                  {formData.tier === 'reklam-alani' && (
                    <span className="text-gold text-xs ml-2">(Otomatik aktif)</span>
                  )}
                </label>
                <p className="text-white/60 text-xs mt-1">
                  Bu kartı reklam kartı olarak işaretle. "REKLAM VER" yazısı ile gösterilir ve tıklandığında ana sayfadaki iletişim bölümüne yönlendirir.
                </p>
              </div>
            </div>
          </div>

          {!formData.is_ad_card && formData.tier !== 'reklam-alani' && (
            <div className="border-t border-gold/20 pt-4 mt-4">
              <h3 className="text-gold font-bold mb-3 flex items-center gap-2">
                <span className="text-2xl">✨</span>
                Buton Ayarları
              </h3>
              
              <div className="space-y-3">
                <div>
                  <label className="block text-white mb-2">Buton Yazısı *</label>
                  <input
                    type="text"
                    value={formData.button1_text}
                    onChange={(e) => setFormData({ ...formData, button1_text: e.target.value })}
                    className="w-full px-3 py-2 bg-navy-600 border border-gold/30 rounded text-white focus:border-gold focus:ring-2 focus:ring-gold/20"
                    placeholder="Örn: Siteye Git, Kayıt Ol"
                    required={!formData.is_ad_card && formData.tier !== 'reklam-alani'}
                  />
                </div>

                <div>
                  <label className="block text-white mb-2">Buton Linki *</label>
                  <input
                    type="url"
                    value={formData.button1_link}
                    onChange={(e) => setFormData({ ...formData, button1_link: e.target.value })}
                    className="w-full px-3 py-2 bg-navy-600 border border-gold/30 rounded text-white focus:border-gold focus:ring-2 focus:ring-gold/20"
                    placeholder="https://example.com"
                    required={!formData.is_ad_card && formData.tier !== 'reklam-alani'}
                  />
                </div>
              </div>
            </div>
          )}

          <div>
            <label className="block text-white mb-2">Başlık Kategorisi</label>
            <select
              value={formData.section_id}
              onChange={(e) => setFormData({ ...formData, section_id: e.target.value })}
              className="w-full px-3 py-2 bg-navy-600 border border-gold/30 rounded text-white"
            >
              <option value="">Seçiniz</option>
              {sections.map(section => (
                <option key={section.id} value={section.id}>{section.title}</option>
              ))}
            </select>
          </div>

          <div>
            <label className="block text-white mb-2">Sıra</label>
            <input
              type="number"
              value={formData.order_index}
              onChange={(e) => setFormData({ ...formData, order_index: parseInt(e.target.value) })}
              className="w-full px-3 py-2 bg-navy-600 border border-gold/30 rounded text-white"
            />
          </div>

          <div>
            <label className="block text-white mb-2">Bilet Çarpanı</label>
            <select
              value={formData.ticket_multiplier}
              onChange={(e) => setFormData({ ...formData, ticket_multiplier: parseInt(e.target.value) })}
              className="w-full px-3 py-2 bg-navy-600 border border-gold/30 rounded text-white"
            >
              <option value="1">1x (Normal)</option>
              <option value="2">2x</option>
              <option value="3">3x</option>
              <option value="4">4x</option>
              <option value="5">5x</option>
              <option value="6">6x</option>
            </select>
            <p className="text-white/60 text-xs mt-1">
              Bu siteden bilet alındığında çarpan kadar bilet verilecektir. Örn: 500₺ bilet fiyatı, 1000₺ yatırım = 2 bilet (normal), 3x çarpan ile = 6 bilet
            </p>
          </div>

          <div className="flex items-center gap-2">
            <input
              type="checkbox"
              checked={formData.is_active}
              onChange={(e) => setFormData({ ...formData, is_active: e.target.checked })}
              className="w-4 h-4"
            />
            <label className="text-white">Aktif</label>
          </div>

          <button
            type="submit"
            disabled={loading}
              className="w-full bg-gradient-to-r from-gold to-yellow-500 hover:from-yellow-500 hover:to-gold text-navy-900 font-bold py-2 px-4 rounded-lg transition-all duration-300 shadow-gold disabled:opacity-50"
          >
            {loading ? 'Kaydediliyor...' : (editingItem ? 'Güncelle' : 'Ekle')}
          </button>
        </form>
      )}

      <div className="space-y-4">
        {sponsors.map((sponsor) => (
          <div key={sponsor.id} className="bg-navy-700 p-4 rounded-lg flex items-center gap-4">
            {sponsor.logo_url && (
              <img
                src={sponsor.logo_url && sponsor.logo_url.startsWith('http') ? sponsor.logo_url : sponsor.logo_url || ''}
                alt={sponsor.name}
                className="w-20 h-20 object-contain rounded bg-white/5"
              />
            )}
            <div className="flex-1">
              <h3 className="text-white font-bold flex items-center gap-2">
                {sponsor.name}
                {(sponsor.is_ad_card === 1 || sponsor.is_ad_card === true) && (
                  <span className="bg-gradient-to-r from-gold to-yellow-500 text-navy-900 text-xs px-2 py-1 rounded-full font-semibold shadow-[0_0_10px_rgba(212,175,55,0.5)]">
                    REKLAM
                  </span>
                )}
              </h3>
              <p className="text-white/60 text-sm">Seviye: {sponsor.tier}</p>
              <p className="text-white/60 text-sm">Kategori: {sponsor.section_title || 'Yok'}</p>
              <p className="text-white/60 text-sm">Durum: {sponsor.is_active ? 'Aktif' : 'Pasif'}</p>
              <p className="text-white/60 text-sm">Arkaplan Görseli: {sponsor.bg_image_url ? 'Var' : 'Yok (varsayılan)'}</p>
            </div>
            <div className="flex gap-2">
              <button
                onClick={() => handleCopy(sponsor)}
                className="bg-gradient-to-r from-gold to-yellow-500 hover:from-yellow-500 hover:to-gold text-navy-900 font-semibold px-3 py-1 rounded transition-all duration-300 shadow-gold"
                title="Sponsoru kopyala"
              >
                Kopyala
              </button>
              <button
                onClick={() => handleEdit(sponsor)}
                className="bg-blue-500 hover:bg-blue-600 text-white px-3 py-1 rounded transition-all duration-300"
              >
                Düzenle
              </button>
              <button
                onClick={() => handleDelete(sponsor.id)}
                className="bg-red-500 hover:bg-red-600 text-white px-3 py-1 rounded transition-all duration-300"
              >
                Sil
              </button>
            </div>
          </div>
        ))}

        {sponsors.length === 0 && (
          <p className="text-center text-white/60 py-8">Henüz sponsor eklenmedi</p>
        )}
      </div>
    </div>
  );
};

export default SponsorManager;
